"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
class GetDefaultPropositionsResponseProductDetailsElectricityRates extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({ example: 0.048, description: 'Single meter rate excl. VAT' }),
    tslib_1.__metadata("design:type", Number)
], GetDefaultPropositionsResponseProductDetailsElectricityRates.prototype, "electricityStandardRate", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({ example: 0.055, description: 'Double meter peak rate excl. VAT' }),
    tslib_1.__metadata("design:type", Number)
], GetDefaultPropositionsResponseProductDetailsElectricityRates.prototype, "electricityPeakRate", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({ example: 0.055, description: 'Double meter peak rate excl. VAT for Brabant and Limburg' }),
    tslib_1.__metadata("design:type", Number)
], GetDefaultPropositionsResponseProductDetailsElectricityRates.prototype, "electricityPeakRate_07_21", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({ example: 0.0415, description: 'Double meter off-peak rate excl. VAT' }),
    tslib_1.__metadata("design:type", Number)
], GetDefaultPropositionsResponseProductDetailsElectricityRates.prototype, "electricityOffPeakRate", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({ example: 0.0415, description: 'Double meter off-peak rate excl. VAT for Brabant and Limburg' }),
    tslib_1.__metadata("design:type", Number)
], GetDefaultPropositionsResponseProductDetailsElectricityRates.prototype, "electricityOffPeakRate_07_21", void 0);
exports.default = GetDefaultPropositionsResponseProductDetailsElectricityRates;
